// Mobile drawer: opens from the hamburger, closes on the close button, the backdrop or Escape,
// keeps focus inside while open and returns it to the toggle on close.
(function () {
  'use strict';

  var drawer = document.querySelector('[data-drawer]');
  var toggle = document.querySelector('[data-drawer-open]');
  if (!drawer || !toggle) return;
  var panel = drawer.querySelector('[data-drawer-panel]');
  var CLOSE_MS = 360;
  var closeTimer = null;

  // Same rule as the motion CSS: the theme setting and the visitor's reduced-motion preference.
  function motionAllowed() {
    return document.documentElement.dataset.motion !== 'none' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function focusable() {
    return panel.querySelectorAll('a[href], button:not([disabled])');
  }

  function open() {
    clearTimeout(closeTimer);
    drawer.hidden = false;
    // Next frame, so the slide-in transition starts from the closed position.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    });
    toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('drawer-open');
    panel.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    drawer.classList.remove('is-open');
    // Keep the drawer in the page until the slide-out finishes; hide at once without motion.
    if (motionAllowed()) {
      closeTimer = setTimeout(function () { drawer.hidden = true; }, CLOSE_MS);
    } else {
      drawer.hidden = true;
    }
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('drawer-open');
    document.removeEventListener('keydown', onKeydown);
    toggle.focus();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var items = focusable();
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  toggle.addEventListener('click', open);
  drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  // Close when the viewport grows past the drawer breakpoint.
  window.matchMedia('(min-width: 1025px)').addEventListener('change', function (mq) {
    if (mq.matches && !drawer.hidden) close();
  });

})();

// Keeps every "Carrito (n)" link in sync after cart changes made with the Cart API.
document.addEventListener('cart:updated', function (event) {
  var count = event.detail && typeof event.detail.item_count === 'number' ? event.detail.item_count : null;
  if (count === null) return;
  document.querySelectorAll('[data-cart-link]').forEach(function (link) {
    link.textContent = link.textContent.replace(/\(\d+\)/, '(' + count + ')');
    // Restart the bump animation (CSS, motion-gated) on every change.
    link.classList.remove('is-bumped');
    void link.offsetWidth;
    link.classList.add('is-bumped');
  });
});
